<script setup>
import { computed, ref, watch } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: 'Häufig gestellte Fragen'
  },
  subtitle: {
    type: String,
    default: 'Hier finden Sie Antworten auf die wichtigsten Fragen zu unseren Fotoboxen.'
  },
  faqItems: {
    type: Array,
    required: true
  },
  locationName: {
    type: String,
    default: ''
  }
})

const openIndex = ref(props.faqItems.length > 0 ? 0 : null)

const displayTitle = computed(() => {
  if (props.locationName) {
    return `Häufig gestellte Fragen zu Fotoboxen in ${props.locationName}`
  }
  return props.title
})

const toggleItem = (index) => {
  openIndex.value = openIndex.value === index ? null : index
}

watch(
  () => props.faqItems.length,
  (length) => {
    if (length === 0) {
      openIndex.value = null
      return
    }

    if (openIndex.value === null || openIndex.value >= length) {
      openIndex.value = 0
    }
  },
  { immediate: true }
)
</script>

<template>
  <section class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <h2 class="heading-2 mb-4">{{ displayTitle }}</h2>
        <p class="text-lg text-gray-600 max-w-3xl mx-auto">{{ subtitle }}</p>
      </div>

      <div class="max-w-3xl mx-auto space-y-4">
        <div
          v-for="(faq, index) in faqItems"
          :key="index"
          class="border border-gray-200 rounded-lg overflow-hidden bg-white"
        >
          <button
            type="button"
            class="w-full flex items-center justify-between gap-4 p-5 text-left font-semibold text-gray-900 transition-colors hover:bg-gray-50"
            :aria-expanded="openIndex === index"
            :aria-controls="`faq-answer-${index}`"
            @click="toggleItem(index)"
          >
            <span>{{ faq.question }}</span>
            <span
              class="shrink-0 text-2xl leading-none text-primary transition-transform duration-200"
              :class="{ 'rotate-45': openIndex === index }"
              aria-hidden="true"
            >
              +
            </span>
          </button>

          <div
            v-show="openIndex === index"
            :id="`faq-answer-${index}`"
            class="px-5 pb-5 text-gray-600"
          >
            {{ faq.answer }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
